module.exports = __webpack_public_path__ + "lowest-price-report.svg?526d779ca8979941760929cbcc30a739";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowest-price-report.svg
// module id = 292
// module chunks = 2